module.exports = __webpack_public_path__ + "static/media/Y7.846863a4.mp3";